module.exports = __webpack_public_path__ + "static/media/tmlogo.ca36a6f3.svg";